<template>
  <div>
    <UserMyReviewPage></UserMyReviewPage>
  </div>
</template>

<script>
import UserMyReviewPage from "@/components/user/UserMyReviewPage.vue";

export default {
  name: "UserMyReviewPageView",
  components: {
    UserMyReviewPage
  }
};
</script>

<style></style>
